import { render, staticRenderFns } from "./TeamNavItems.vue?vue&type=template&id=3ce12bc5&scoped=true&"
import script from "./TeamNavItems.vue?vue&type=script&lang=ts&"
export * from "./TeamNavItems.vue?vue&type=script&lang=ts&"
import style0 from "./TeamNavItems.vue?vue&type=style&index=0&id=3ce12bc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce12bc5",
  null
  
)

export default component.exports